// ref: https://stackoverflow.com/questions/59183495/cant-get-lodash-debounce-to-work-properly-executed-multiple-times-reac
import { useCallback, useRef } from 'react';
import _debounce from 'lodash/debounce';

export default function useDebouncedCallback(callback: any, delay: number, opts: any = {}) {
  const callbackRef = useRef<any>();
  callbackRef.current = callback;

  return useCallback(
    _debounce((...args: any) => callbackRef.current(...args), delay, opts),
    [],
  );
}
